import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalProspectFinderSupplierHqDocument = gql`
  query SalesPortalProspectFinderSupplierHq($supplierUUID: uuid!) {
    businesses_by_pk(uuid: $supplierUUID) {
      uuid
      address {
        latitude
        longitude
        uuid
      }
    }
  }
`;
export function useSalesPortalProspectFinderSupplierHqQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalProspectFinderSupplierHqQuery,
    Types.SalesPortalProspectFinderSupplierHqQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalProspectFinderSupplierHqQuery,
    Types.SalesPortalProspectFinderSupplierHqQueryVariables
  >(SalesPortalProspectFinderSupplierHqDocument, options);
}
export function useSalesPortalProspectFinderSupplierHqLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalProspectFinderSupplierHqQuery,
    Types.SalesPortalProspectFinderSupplierHqQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalProspectFinderSupplierHqQuery,
    Types.SalesPortalProspectFinderSupplierHqQueryVariables
  >(SalesPortalProspectFinderSupplierHqDocument, options);
}
export type SalesPortalProspectFinderSupplierHqQueryHookResult = ReturnType<
  typeof useSalesPortalProspectFinderSupplierHqQuery
>;
export type SalesPortalProspectFinderSupplierHqLazyQueryHookResult = ReturnType<
  typeof useSalesPortalProspectFinderSupplierHqLazyQuery
>;
export type SalesPortalProspectFinderSupplierHqQueryResult = Apollo.QueryResult<
  Types.SalesPortalProspectFinderSupplierHqQuery,
  Types.SalesPortalProspectFinderSupplierHqQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalProspectFinderSupplierHqQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalProspectFinderSupplierHqQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalProspectFinderSupplierHqQuery,
    Types.SalesPortalProspectFinderSupplierHqQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalProspectFinderSupplierHqQuery,
    Types.SalesPortalProspectFinderSupplierHqQueryVariables
  >(SalesPortalProspectFinderSupplierHqDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalProspectFinderSupplierHqLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalProspectFinderSupplierHqLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalProspectFinderSupplierHqQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalProspectFinderSupplierHqQuery,
    Types.SalesPortalProspectFinderSupplierHqQueryVariables
  >(SalesPortalProspectFinderSupplierHqDocument, lazyOptions);
}
